module.exports = __webpack_public_path__ + "img/wasabi.3d59a6d2.png";